import { render, staticRenderFns } from "./CardEscolaridade.vue?vue&type=template&id=0bc5aef2&"
import script from "./CardEscolaridade.vue?vue&type=script&lang=js&"
export * from "./CardEscolaridade.vue?vue&type=script&lang=js&"
import style0 from "./CardEscolaridade.vue?vue&type=style&index=0&id=0bc5aef2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports